import { OrderValidationBreakdown } from './types/basket-types';
import { SumNumber } from './utils/array';

export const GetDdpAdminFee = (breakdown: OrderValidationBreakdown) =>
  SumNumber(breakdown.filter((x) => x.name === 'DDP Admin Fee').map((x) => x.amount));

export const GetDdpTax = (breakdown: OrderValidationBreakdown) =>
  SumNumber(breakdown.filter((x) => x.name === 'DDP Tax').map((x) => x.amount));

export const GetDdpDuty = (breakdown: OrderValidationBreakdown) =>
  SumNumber(breakdown.filter((x) => x.name === 'DDP Duty').map((x) => x.amount));

export const GetDdpDutyAndTax = (breakdown: OrderValidationBreakdown) => GetDdpDuty(breakdown) + GetDdpTax(breakdown);

export const GetUnderpayments = (breakdown: OrderValidationBreakdown) =>
  SumNumber(breakdown.filter((x) => x.name === 'Underpayment').map((x) => x.amount));

export const GetProtectionCost = (breakdown: OrderValidationBreakdown) =>
  SumNumber(breakdown.filter((x) => x.name === 'ExtendedBase' || x.name === 'Protection').map((x) => x.amount));

export const GetLocalTaxCost = (breakdown: OrderValidationBreakdown) =>
  SumNumber(breakdown.filter((x) => x.name === 'Local Tax').map((x) => x.amount));
